import { render, staticRenderFns } from "./InvoiceHeader.vue?vue&type=template&id=5ff18576&scoped=true&"
import script from "./InvoiceHeader.vue?vue&type=script&lang=js&"
export * from "./InvoiceHeader.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceHeader.vue?vue&type=style&index=0&id=5ff18576&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff18576",
  null
  
)

export default component.exports